export const interactionConfig = {
  /** ~1 frame @ 60fps */
  mousemoveThrottleMs: 16,
  /** Series whose nearest points are within this vertical distance share one tooltip. */
  tooltipGroupingThresholdPx: 20,
  /**
   * Horizontal reach of the tooltip on each side of the pointer. Within it the sample closest to the
   * pointer's height wins, so pointing at a zoomed-out spike shows its peak, not the baseline next
   * to it. At least one thinning bucket wide (see lineDrawingBudget), so every drawn point is reachable.
   */
  tooltipSnapRadiusPx: 4,
  tooltipOffset: 12,
  viewportMargin: 8,
  /**
   * Quiet time after the last zoom or pan event before the detailed data for the new window is
   * built. While the gesture runs ECharts moves the already-drawn, budget-sized data on its own;
   * rebuilding on every event would put the option rebuild back on each wheel step.
   */
  viewportSettleMs: 100,
} as const;
